export const HIVE_STATIC_VERSION = 'v0.1.11';

export const SCROLL_DEBOUNCE_DELAY = 100;
export const DEBOUNCE_DELAY = 200;
export const WIDTH_SM = 576;
export const LINK_STACK = {
  APPLY_VIEW_MORE: 3,
  DISABLE_PARENT_CLICK: WIDTH_SM,
};
export default {};

export const SCREEN_BREAKPOINTS = {
  XS: 360,
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1200,
};

export const BREAKPOINTS = {
  XS: `${SCREEN_BREAKPOINTS.XS}px`,
  SM: `${SCREEN_BREAKPOINTS.SM}px`,
  MD: `${SCREEN_BREAKPOINTS.MD}px`,
  LG: `${SCREEN_BREAKPOINTS.LG}px`,
  XL: `${SCREEN_BREAKPOINTS.XL}px`,
};

export enum ENV {
  INTEGRATION = 'integration',
  STAGING = 'staging',
  PRODUCTION = 'production',
  SANDBOX = 'sandbox',
  LOCAL = 'local',
}

export enum REGION {
  SG = 'sg',
  MY = 'my',
  TH = 'th',
  ID = 'id',
}

export enum MARKETPLACE {
  PG = 'pg',
  CG = 'cg',
}

export enum LOCALE {
  EN = 'en',
  MS = 'ms',
  ID = 'id',
  TH = 'th',
}

export enum PropertyTypeMarket {
  RESIDENTIAL = 'residential',
  COMMERCIAL = 'commercial',
}

export enum KEYBOARD {
  ARROW_LEFT = 'ArrowLeft',
  ARROW_RIGHT = 'ArrowRight',
  BACKSPACE = 'Backspace',
  DELETE = 'Delete',
  TAB = 'Tab',
}

export const EMAIL_VALIDATION_PATTERN =
  '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$';

export enum SocialProvider {
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

/**
 * Using "as const" ensures that the object properties are read-only,
 * preventing any accidental modifications to the object's properties.
 * This can be useful for ensuring immutability in code,
 * which can help prevent bugs and make code more predictable.
 */
export const CountryCode = {
  [REGION.SG]: 65,
  [REGION.MY]: 60,
  [REGION.TH]: 66,
  [REGION.ID]: 62,
} as const;

export enum ContactInputType {
  EMAIL = 'email',
  MOBILE = 'mobile',
}

export const DATA_AUTOMATION_ID = 'dataAutomationId';

export const condominiumTypes = ['Apartment', 'Condominium', 'Executive Condominium'];

export const hdbTypes = ['HDB'];

export const landedTypes = ['Terrace House', 'Semi-Detached House', 'Detached House'];

export enum PropertyType {
  Condo = 'Condo',
  Landed = 'Landed',
  HDB = 'HDB',
}

export enum PriceType {
  ASK = 'ASK',
  START = 'START',
  RANGE = 'RANGE',
}

export const propertyTypeMap = {
  [PropertyType.Condo]: condominiumTypes,
  [PropertyType.HDB]: hdbTypes,
  [PropertyType.Landed]: landedTypes,
};

export enum SearchCategory {
  BUY = 'buy',
  RENT = 'rent',
}

export enum HomeSellersAddonServicesName {
  SEND_HELPER = 'sendHelper',
  PG_FINANCE = 'pgFinance',
}
